import { Trans } from '@lingui/react/macro';
import { Button, ButtonBar } from '@/components/Buttons';
import { Modal, ModalBody } from '@ygtechnologies/bygr-frontend-component-library';
import React from 'react';
import theme from './StandardReplies.module.scss';

type DeleteStandardReplyModalProps = {
    isOpen: boolean;
    toggle: () => void;
    confirmDeleteReply: () => void;
};

const DeleteStandardReplyModal: React.FC<DeleteStandardReplyModalProps> = ({ isOpen, toggle, confirmDeleteReply }) => {
    return (
        <Modal closeOnEscape={false} isOpen={isOpen} toggle={toggle} size="lg">
            <ModalBody className={theme.container}>
                <div className={theme.heading}>
                    <Trans>Are you sure you want to delete the reply?</Trans>
                </div>
                <div className={theme.deleteInfo}>
                    <Trans>
                        It will then disappear from the list. If you change your mind later, then you have to start all over
                        again.
                    </Trans>
                </div>
                <ButtonBar>
                    <div className={theme.buttonBarNewReply}>
                        <Button onClick={toggle} color="tertiary">
                            <Trans>Cancel</Trans>
                        </Button>
                        <Button onClick={confirmDeleteReply} loading={undefined} color="danger">
                            <Trans>Delete</Trans>
                        </Button>
                    </div>
                </ButtonBar>
            </ModalBody>
        </Modal>
    );
};
export default DeleteStandardReplyModal;